import React from 'react'
import ReactDOM from 'react-dom/client'
import TagManager from 'react-gtm-module'

import App from './App'

import './index.scss'

// if (process.env.NODE_ENV === 'production') {
TagManager.initialize({
  gtmId: 'GTM-NP6NJMP',
})
// }

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
